<div class="header">
  <div class="filterbar"></div>
  <div class="toolbar">
    @if (!readOnly && !!testObjects && testObjects?.length !== 0) {
      <button pButton label="Add Test Objects" (click)="openAddObjects($event)">
        <fa-icon [icon]="faPlus"></fa-icon>
      </button>
    }
  </div>
</div>
<div class="content">
  @if (!!resolutionJob) {
    <div class="empty resolution-panel">
      @if (!hasResolutionTerminalState(resolutionJob)) {
        <p-progressSpinner strokeWidth="4"></p-progressSpinner>
      }
      <div class="empty-text">{{ getResolutionTitle(resolutionJob) }}</div>
      <div class="resolution-message">{{ getResolutionMessage(resolutionJob) }}</div>
      <div class="resolution-progress">
        <p-progressBar [value]="getResolutionProgressPercent(resolutionJob)" [showValue]="true"></p-progressBar>
      </div>
    </div>
  }
  @if (!resolutionJob && testObjects?.length === 0) {
    <div class="empty">
      <div class="empty-text">No test objects</div>
      @if (!readOnly) {
        <p-button label="Create First Test Objects" data-testing-id="create-first-test-objects-btn" (click)="openAddObjects($event)"></p-button>
      }
    </div>
  }
	  @if (!resolutionJob && (testObjects?.length || 0) > 0) {
	    <div class="objects">
	      @for (obj of testObjects; track obj.testObjectId; let i = $index) {
	        <div class="test-object" [ngClass]="{'selected': obj.testObjectId === selectedTestObjectId}" (click)="selectObject(obj.testObjectId)">
	          <wm-test-object-summary [target]="obj.target" [representativeStateId]="representativeStateIdByTestObjectId[obj.testObjectId]"></wm-test-object-summary>
	        </div>
	      }
	    </div>
	  }
	  @if (!!selectedTestObjectId && !!testObjectsById[selectedTestObjectId]) {
	    <div class="selected-object">
	      <wm-test-object-detail
	        [readOnly]="readOnly"
	        [projectId]="projectId"
	        [auditId]="auditId"
            [closable]="false"
	        [selectedTestObject]="testObjectsById[selectedTestObjectId]"
	        [testObjectsById]="testObjectsById"
            [canonicalTestObject]="canonicalTestObjectsById[selectedTestObjectId]"
            [representativeStateId]="representativeStateIdByTestObjectId[selectedTestObjectId]"
            [captureJob]="getCaptureJob(selectedTestObjectId)"
            [stateCaptureAvailable]="isRepresentativeStateCaptureAvailable(selectedTestObjectId)"
            [stateCaptureUnavailableReason]="getRepresentativeStateCaptureUnavailableReason(selectedTestObjectId)"
	        (onDeleteTestObject)="openRemovalDialog($event)"
	        (onUpdateTestObject)="updateTestObject($event)"
	        (onViewState)="viewState($event)"
	        (onSetTags)="setTagsForSelectedTestObject($event)"
            (onCaptureRepresentativeState)="captureRepresentativeState($event)"
	      ></wm-test-object-detail>
	    </div>
	  }
</div>
